/* Office client data model
 *
 * Angular Module: trackerbase-app.models.office
 * Injected Factory: Office
 */

import NumberFormatter from "../utility/NumberFormatter";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

class Office {
    constructor(
        officeId,
        officeType,
        district,
        officeState,
        officeElections,
        officeSubscribers
    )
    {
        if (Number.isInteger(officeId))
        {
            this.officeId = officeId;
        }
        else {
            throw new TypeError("Invalid or missing required office id");
        }

        if ((officeType != null) &&
            //officeType is duck-typed as an OfficeType object.
            (angular.isDefined(officeType.officeTypeName)))
        {
            this.officeType = officeType;
        }
        else {
            throw new TypeError("Invalid or missing office type");
        }

        if ((district != null) &&
            (angular.isString(district)))
        {
            this.officeDistrict = district;
        }
        else {
            throw new TypeError("Invalid or missing required office district");
        }

        // We could require this,
        // but when office is in a hierarchy
        // as a child of a State object,
        // having the reference creates a loop.
        // Any class instance methods will need to ensure
        // they handle this behavior.
        this.officeState = null;

        if ((officeState != null) &&
            (angular.isDefined(officeState.shortName)))
        {
            this.officeState = officeState;
        }

        this.officeElections = [];

        if ((officeElections != null) &&
            (angular.isArray(officeElections)))
        {
            Array.prototype.push.apply(this.officeElections, officeElections);
        }

        this.officeSubscribers = [];
        if ((officeSubscribers != null) &&
            (angular.isArray(officeSubscribers)))
        {
            Array.prototype.push.apply(this.officeSubscribers, officeSubscribers);
        }
    }

    toString() {
        return `${this.officeType.officeTypeName}-${this.officeDistrict} (${this.officeId})`;
    }

    valueOf() {
        return this.officeId;
    }

    get officeName() {
        let officeNameParts = [];
        if (this.officeState != null) {
            officeNameParts.push(this.officeState.displayName);
        }
        officeNameParts.push(Office.formatDisplayName(this));

        return officeNameParts.join(" - ");
    }

    get displayName() {
        return this.officeName;
    }

    _officeDistrictSortable() {
        let parsedDistrict = Number.parseInt(this.officeDistrict, 10);
        if (Number.isNaN(parsedDistrict)) {
            return this.officeDistrict;
        }
        else {
            return parsedDistrict.toString().padStart(4, "0");
        }
    }

    get sortAs() {
        let sortParts = [
            this.officeType.sortAs
        ];
        if (this.officeState !== null) {
            //Deliberate choice not to use State.sortAs - which currently uses state full names.
            //Short names are easy as they are always 2 characters.
            sortParts.push(this.officeState.shortName);
        }
        else {
            sortParts.push("ZZ");
        }
        sortParts.push(this._officeDistrictSortable());
        return sortParts.join(".");
    }

    get subscribableId() {
        return this.officeId;
    }

    static formatDisplayName(officeObj) {
        if (officeObj == null) {
            return null;
        }

        if (officeObj.officeType == null) {
            return null;
        }

        let displayNameParts = [ officeObj.officeType.officeTypeName ];
        if (officeObj.officeType.officeTypeName === "House") {
            displayNameParts.push("-");
            let numericDistrict = parseInt(officeObj.officeDistrict);
            if (!Number.isNaN(numericDistrict)) {
                let formattedCDNumber = NumberFormatter(numericDistrict);
                displayNameParts.push(formattedCDNumber, "District");
            }
            else {
                displayNameParts.push(officeObj.officeDistrict);
            }
        }

        return displayNameParts.join(" ");
    }


}

makePropsEnumerable(Office.prototype, [
    "officeName",
    "displayName",
    "sortAs",
    "subscribableId"
]);

export default Office;



//////////////////
// WEBPACK FOOTER
// ./src/models/Office.js
// module id = KUhs
// module chunks = 1